module.exports = __webpack_public_path__ + "4f640784aa22da0baac7d3c4f4a12925.svg";